import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "SiteNavListViewContainer"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "leftCenter"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "leftCenter"
};
const _hoisted_6 = {
  class: "leftCenter"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EmdEnumValueListView = _resolveComponent("EmdEnumValueListView");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sites, site => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: `site_${site.value}`,
        label: site.label,
        name: site.label
      }, {
        default: _withCtx(() => [_createVNode(_component_EmdEnumValueListView, {
          type: "SITE_NAV",
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'SITE_NAV',
            refId: site.value,
            sort: true,
            extra: true,
            labelSlot: true
          },
          title: "站点导航配置",
          "add-btn": `添加${site.label}站点导航`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
          label: _withCtx(data => [_createElementVNode("span", {
            class: "ptr",
            onClick: $event => $options.viewSub(data.data),
            style: {
              "color": "#009FFF"
            }
          }, _toDisplayString(data.data.label), 9, _hoisted_2)]),
          _: 2
        }, 1032, ["init-query", "add-btn"]), _createVNode(_component_EmdEnumValueListView, {
          type: "HEAD_TOP_LINK",
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'HEAD_TOP_LINK',
            refId: site.value,
            sort: true,
            extra: true,
            labelSlot: true
          },
          title: "顶部快捷导航配置",
          "add-btn": `添加${site.label}站点顶部快捷导航`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
          label: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.label), 1)]),
          _: 2
        }, 1032, ["init-query", "add-btn"]), _createVNode(_component_EmdEnumValueListView, {
          type: "USEFUL_TOOLS",
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'USEFUL_TOOLS',
            refId: site.value,
            sort: true,
            extra: true,
            labelSlot: true
          },
          title: "常用工具导航",
          "add-btn": `添加${site.label}站点常用工具导航`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
          label: _withCtx(data => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(data.data.label), 1), _createElementVNode("img", {
            src: data.data.extra.ICON,
            class: "sqr40 ml16"
          }, null, 8, _hoisted_4)])]),
          _: 2
        }, 1032, ["init-query", "add-btn"]), _createVNode(_component_EmdEnumValueListView, {
          type: "SCHOOL_INFO_NAV",
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'SCHOOL_INFO_NAV',
            refId: site.value,
            sort: true,
            extra: true,
            labelSlot: true
          },
          title: "学校详情页栏目",
          "add-btn": `添加${site.label}学校详情页栏目`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
          label: _withCtx(data => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(data.data.label), 1)])]),
          _: 2
        }, 1032, ["init-query", "add-btn"]), _createVNode(_component_EmdEnumValueListView, {
          type: "SITE_SLIDE_AD",
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'SITE_SLIDE_AD',
            refId: site.value,
            sort: true,
            extra: false,
            labelSlot: true
          },
          title: "侧边栏浮层",
          "add-btn": `添加${site.label}侧边栏浮层`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
          label: _withCtx(data => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(data.data.label), 1), _createElementVNode("img", {
            src: data.data.extra.ICON,
            class: "sqr40 ml16"
          }, null, 8, _hoisted_7), _createElementVNode("img", {
            src: data.data.extra.IMG,
            class: "sqr40 ml16"
          }, null, 8, _hoisted_8)])]),
          _: 2
        }, 1032, ["init-query", "add-btn"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_DialogCustomView, {
    "visible-control": $data.subNavVisible,
    width: "1200px",
    title: "二级导航",
    onClose: _cache[1] || (_cache[1] = $event => $data.subNavVisible = false)
  }, {
    default: _withCtx(() => [$data.subNavVisible ? (_openBlock(), _createBlock(_component_EmdEnumValueListView, {
      key: 0,
      type: "SITE_2_NAV",
      "show-title": false,
      sort: "",
      "init-query": {
        type: 'SITE_2_NAV',
        refId: $data.mainNav.id,
        sort: true,
        extra: true
      },
      title: "站点二级导航配置",
      "add-btn": `添加${$data.mainNav.label}二级导航`
    }, {
      extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
      _: 1
    }, 8, ["init-query", "add-btn"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}